// extracted by mini-css-extract-plugin
module.exports = {"small":"MushroomBronzeIcon_small__3ViY4","extraSmall":"MushroomBronzeIcon_extraSmall__3osCN"};